import { ICubeSchemaMapper } from './cube-schema-mapper.interface';

export interface ITopAppsReportMapper extends ICubeSchemaMapper {}
